import { render, staticRenderFns } from "./ComponenteLoginSgeClienteFabricante.vue?vue&type=template&id=ffe47d46&"
import script from "./ComponenteLoginSgeClienteFabricante.vue?vue&type=script&lang=js&"
export * from "./ComponenteLoginSgeClienteFabricante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports